module.exports = __webpack_public_path__ + "img/logo-ascent.2b1c739cc0c3c8b2d07d59a70cdd62ae.png";